var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalTim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7211 52.6569H28.6485C28.1921 52.6569 27.7797 52.8468 27.4816 53.1542C27.1836 53.4601 27 53.8822 27 54.3495V57.2579C27 57.7236 27.1823 58.1458 27.4776 58.4505C27.777 58.7592 28.1908 58.9505 28.6485 58.9505H40.7211V52.6569ZM61.4489 53.1582C61.1508 52.8508 60.7357 52.6569 60.278 52.6569H48.2053V58.9505H60.278C60.7357 58.9505 61.1495 58.7592 61.4489 58.449C61.7442 58.1444 61.9265 57.7222 61.9265 57.2579V54.3495C61.9265 53.8849 61.7442 53.4642 61.4489 53.1582ZM61.4489 41.8309C61.1508 41.521 60.7357 41.3284 60.278 41.3284H48.2053V47.622H60.278C60.7357 47.622 61.1495 47.4281 61.4489 47.1195C61.7442 46.8137 61.9265 46.393 61.9265 45.9288V43.0203C61.9265 42.5574 61.7442 42.1368 61.4489 41.8309ZM40.7211 41.3284L28.6485 41.3298C28.1921 41.3298 27.7797 41.5196 27.4816 41.8268C27.1836 42.1327 27 42.5546 27 43.0203V45.9288C27 46.393 27.1823 46.815 27.4776 47.1208C27.777 47.4294 28.1908 47.622 28.6485 47.622H40.7211V41.3284ZM60.2481 36.2936H28.6784C28.2124 36.2936 27.7911 36.1023 27.4863 35.7936C27.1856 35.4876 27 35.0668 27 34.601V31.6926C27 31.2254 27.1869 30.8033 27.489 30.4973C27.7938 30.1899 28.2138 30 28.6784 30H60.2481C60.7141 30 61.1367 30.1913 61.4401 30.5014C61.7408 30.8074 61.9265 31.2281 61.9265 31.6926V34.601C61.9265 35.0655 61.7408 35.4862 61.4401 35.7922C61.1354 36.1023 60.7141 36.2936 60.2481 36.2936Z",
    fill: "#EB0028"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalTim);
export default __webpack_public_path__ + "static/media/logoModalTim.dc9891894bf4aaa820098271445088f3.svg";
export { ForwardRef as ReactComponent };